export default { sha: '39b22dec0b4b65bacd8b6f436ef38710800fd9a4', buildNumber: 'undefined' }
